var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"arrows"},[_c('path',{staticClass:"a1",attrs:{"d":"M0 0 L30 32 L60 0"}}),_vm._v(" "),_c('path',{staticClass:"a2",attrs:{"d":"M0 20 L30 52 L60 20"}}),_vm._v(" "),_c('path',{staticClass:"a3",attrs:{"d":"M0 40 L30 72 L60 40"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a8daef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Animations/ArrowDown.vue
// module id = null
// module chunks = 